import React from 'react';

const CONFIG = {
  working: { color: '#10B981', bg: '#10B98120', label: 'Working', dot: true },
  busy:    { color: '#F59E0B', bg: '#F59E0B20', label: 'Busy',    dot: true },
  broken:  { color: '#EF4444', bg: '#EF444420', label: 'Broken',  dot: false },
  unknown: { color: '#475569', bg: '#47556920', label: 'Unknown', dot: false },
};

export default function StatusBadge({ status, size = 'md' }) {
  const cfg = CONFIG[status] || CONFIG.unknown;
  const small = size === 'sm';

  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: small ? 4 : 6,
      padding: small ? '3px 8px' : '5px 12px',
      borderRadius: 20,
      background: cfg.bg,
      border: `1px solid ${cfg.color}44`,
      fontSize: small ? 11 : 13,
      fontWeight: 600,
      color: cfg.color,
      letterSpacing: '0.3px',
    }}>
      {cfg.dot && (
        <span style={{ position: 'relative', display: 'inline-flex', width: small ? 6 : 8, height: small ? 6 : 8 }}>
          <span style={{
            position: 'absolute', inset: 0, borderRadius: '50%',
            background: cfg.color, opacity: 0.4,
            animation: 'pulse-ring 1.5s ease-out infinite',
          }} />
          <span style={{ width: '100%', height: '100%', borderRadius: '50%', background: cfg.color }} />
        </span>
      )}
      {cfg.label}
    </span>
  );
}
